import HeroBannerSecondary from './HeroBannerSecondary'

export default HeroBannerSecondary
